import React from 'react';
import { Upload, message, Button, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PageLayout from '../../components/PageLayout';

var _ = require('lodash');


const conf = (auth, setLoading) => {
    return {
        multiple: true,
        showUploadList: false,
        name: 'file',
        accept: ".csv",
        action: auth.domain + '/api/upload/geo',
        headers: {
            authorization: 'Bearer ' + auth.getToken(),
        },
        beforeUpload() {
            setLoading(true)
        },
        onDownload(file) {
            // console.log(file);
        },
        onChange(info) {
            if (info.file.status === 'done') {
                setLoading(false)
                var data = info.file.response;
                if (data && data.message && data.status === false) {
                    message.error(data.message, 10);
                    return false;
                }
                // saveByteArray([info.file.response], info.file.name, info.file.type);
                message.success(`${info.file.name} файл успешно загружен`);
            } else if (info.file.status === 'error') {
                setLoading(false)
                message.error(`${info.file.name} ошибка загрузки файла.`, 10);
            }
        }
    }
};

export default function AdminMainUploadGeo(props) {
    const { auth } = props;
    const [loading, setLoading] = React.useState(false)

    return (
        <PageLayout>
            <Card size="small" style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                <Upload disabled={loading} {...conf(auth, setLoading)}>
                    <Button loading={loading} icon={<UploadOutlined />}>Импортировать геоданные</Button>
                </Upload>
            </Card>
        </PageLayout>
    );
}
